<template>
  <span
    class="safe-image"
    :class="[$attrs.class, {'safe-image--fill': fill}]"
    :style="$attrs.style"
    v-on="$listeners"
  >
    <el-image
      v-if="useEl && showImg"
      :src="src"
      class="safe-image__el"
      v-bind="imageAttrs"
      @error="onError"
    >
      <div slot="error" class="safe-image__placeholder">
        {{ label }}
      </div>
    </el-image>
    <img
      v-else-if="showImg"
      :src="src"
      class="safe-image__img"
      v-bind="imageAttrs"
      @error="onError"
    />
    <span v-else class="safe-image__placeholder">{{ label }}</span>
  </span>
</template>

<script>
import { isValidImageSrc } from '@/utils/image'

export default {
  name: 'SafeImage',
  inheritAttrs: false,
  props: {
    src: {
      type: [String, Number],
      default: ''
    },
    el: {
      type: Boolean,
      default: false
    },
    fill: {
      type: Boolean,
      default: false
    },
    emptyText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loadError: false
    }
  },
  computed: {
    useEl() {
      return this.el
    },
    label() {
      return this.emptyText || this.$t('暂无图片')
    },
    showImg() {
      return isValidImageSrc(this.src) && !this.loadError
    },
    imageAttrs() {
      const attrs = { ...this.$attrs }
      delete attrs.class
      delete attrs.style
      return attrs
    }
  },
  watch: {
    src() {
      this.loadError = false
    }
  },
  methods: {
    onError() {
      this.loadError = true
    }
  }
}
</script>

<style scoped lang="scss">
.safe-image {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-sizing: border-box;
  vertical-align: middle;
  line-height: normal;
  flex-shrink: 0;
  min-width: 40px;
  min-height: 40px;

  &--fill {
    display: flex;
    width: 100%;
    height: 100%;
  }
}

.safe-image__img {
  display: block;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.safe-image__el {
  display: block;
  width: 100%;
  height: 100%;
}

.safe-image__placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background: #f3f3f5;
  color: #a8a8a8;
  font-size: 12px;
  line-height: 1.4;
  text-align: center;
  padding: 8px;
  word-break: break-word;
}

/deep/ .safe-image__el.el-image {
  width: 100%;
  height: 100%;
}

/deep/ .safe-image__el .el-image__inner {
  width: 100%;
  height: 100%;
}

/deep/ .safe-image__el .el-image__error {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/SafeImage.vue